import { AppThunkAction } from '..';
import { Action, Reducer } from 'redux'
import { RecommendationModel } from '../../models/RecommendationModel';
import { APIContainer, LogTypes, sawinFunc } from '../sawinLib';
import { SessionModel } from '../../models/SessionModel';
import * as myCfg from '../../AppConfig';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface RecommendationList {
    items: RecommendationModel[];
    loading: boolean;
}

export interface RecommendationRetrieve { type: 'RECOMMENDATION_LOAD', newState: RecommendationList }
export interface RecommendationLoading { type: 'RECOMMENDATION_LOADING' }

export type KnownAction = RecommendationRetrieve | RecommendationLoading;

const initialCallListState: RecommendationList = {
    items: [],
    loading: false
};

export const actionCreators = {
    loadRecommendation: (pSession: SessionModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        //const appState = getState().sessionState.      

        var ServiceMasterNumber = pSession.SelectedSM.id;
        var CompanyCode = pSession.SelectedAR.companyCode;
        dispatch({ type: 'RECOMMENDATION_LOADING' });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/recommendations?pCompanyCode=' + CompanyCode + '&pServiceMaster=' + ServiceMasterNumber,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                if (container.success) {
                    const data: RecommendationModel[] = container.data;
                    dispatch({ type: 'RECOMMENDATION_LOAD', newState: { items: data, loading: false } });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            });
    }
};

export const reducer: Reducer<RecommendationList> = (state: RecommendationList | undefined, incomingAction: Action): RecommendationList => {
        

    if (state === undefined) {
        return initialCallListState;
    }
    const action = incomingAction as KnownAction;
    
    switch (action.type) {
        case 'RECOMMENDATION_LOADING':
            return {
                ...state, loading: true
            };
        case 'RECOMMENDATION_LOAD':
            
            const loadRecmdAction = incomingAction as RecommendationRetrieve;
            return loadRecmdAction.newState;

        default:
            return state;
    }
}; 